<template>
  <div>
    <div class="form-control">
      <el-input v-model="imageValue" placeholder="URL изображения" />
      <div>|</div>
      <ImageUpload
        class="small"
        v-model="imageValue"
        :type="type"
        :timestamp="timestamp"
        :rec-width="recWidth"
        :rec-height="recHeight"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageUpload from "@/components/FormControlUploadImage";

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "other",
    },
    /**
     * Добавляем хеш к изображению
     */
    timestamp: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Рекомендуемый размер изображения
     */
    recWidth: {
      type: Number,
      required: false,
      default: null,
    },
    recHeight: {
      type: Number,
      required: false,
      default: null,
    },
  },
  components: {
    ImageUpload,
  },
  data() {
    return {
      mode: "string",
    };
  },
  computed: {
    ...mapGetters(["mediaUrl"]),
    imageValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (val && val.search(/^http/) === -1) {
          val = `${this.mediaUrl}/${val}`;
        }
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control {
  display: flex;
  & > * + * {
    margin-left: 10px;
  }
}
</style>
<style>
.small .uploader .el-upload--picture-card {
  height: 50px;
  line-height: 48px;
  margin-top: -5px;
  margin-bottom: -5px;
}
</style>
